import React from "react";
import { Row } from "react-bootstrap";
import {
  SiGooglecloud,
  SiFigma,
  SiPostman,
  SiFirebase,
  SiCloudflare,
  SiSocketdotio,
  SiRazorpay,
  SiTwilio,
  SiGooglegemini,
  SiVercel,
  SiRender,
  SiPlesk,
  SiCpanel,
  SiNginx,
  SiLinux,
  SiGithubactions,
  SiNpm,
  SiBurpsuite,
  SiWireshark,
  SiKalilinux,
  SiJenkins,
  SiGitlab,
  SiTerraform,
  SiAnsible,
  SiPrometheus,
  SiGrafana,
  SiDigitalocean,
  SiHeroku,
  SiNetlify,
  SiInsomnia,
  SiCanva,
  SiBlender,
  SiUbuntu,
  SiDebian,
  SiArchlinux,
  SiAlpinelinux,
  SiParrotsecurity,
  SiBitbucket,
  SiGnubash,
  SiCircleci,
  SiTravisci,
  SiDatadog,
  SiSentry,
  SiNewrelic,
  SiJira,
  SiTrello,
  SiNotion,
  SiSlack,
  SiDiscord,
  SiZoom,
  SiGithubpages,
  SiPnpm,
  SiYarn,
  SiBun,
  SiEslint,
  SiPrettier,
  SiStorybook,
  SiSwagger,
  SiGoogleanalytics,
  SiHotjar,
  SiMailchimp,
  SiStripe,
  SiPaypal,
  SiAuth0,
  SiLetsencrypt,
  SiCloudinary,
  SiGithubcopilot,
  SiChatbot,
  SiMetasploit,
  SiOpenvpn,
  SiOwasp,
  SiSnyk,
  SiHackthebox,
  SiTryhackme,
  SiSplunk,
  SiPaloaltonetworks,
  SiHashicorp,
  SiVault,
  SiBitwarden,
  SiJsonwebtokens,
  SiGooglechrome,
  SiSelenium,
  SiCypress,
  SiJest,
  SiMocha,
  SiDocker,
} from "react-icons/si";
import { FaGithub, FaAws, FaRobot, FaPaintBrush } from "react-icons/fa";
import { VscVscode } from "react-icons/vsc";
import { IoLogoIonic } from "react-icons/io";
import { AiOutlineRobot } from "react-icons/ai";
import { BsCursorFill, BsRobot, BsCloudFill, BsMicrosoftTeams } from "react-icons/bs";
import {
  TbBrandOpenai,
  TbBrandVisualStudio,
  TbBrandPowershell,
  TbBrandVite,
} from "react-icons/tb";

const sections = [
  {
    title: "IDEs & Code Editors",
    items: [
      { icon: <VscVscode />, name: "VS Code", url: "https://code.visualstudio.com/docs" },
      { icon: <TbBrandVisualStudio />, name: "Visual Studio", url: "https://learn.microsoft.com/en-us/visualstudio" },
      { icon: <BsCursorFill />, name: "Cursor", url: "https://docs.cursor.com" },
    ],
  },
  {
    title: "Version Control & CI/CD",
    items: [
      { icon: <FaGithub />, name: "GitHub", url: "https://docs.github.com" },
      { icon: <SiGitlab />, name: "GitLab", url: "https://docs.gitlab.com" },
      { icon: <SiBitbucket />, name: "Bitbucket", url: "https://support.atlassian.com/bitbucket-cloud" },
      { icon: <SiGithubactions />, name: "GitHub Actions", url: "https://docs.github.com/en/actions" },
      { icon: <SiJenkins />, name: "Jenkins", url: "https://www.jenkins.io/doc" },
      { icon: <SiCircleci />, name: "CircleCI", url: "https://circleci.com/docs" },
      { icon: <SiTravisci />, name: "Travis CI", url: "https://docs.travis-ci.com" },
      { icon: <SiGithubcopilot />, name: "Copilot", url: "https://docs.github.com/en/copilot" },
    ],
  },
  {
    title: "Design & Creative",
    items: [
      { icon: <SiFigma />, name: "Figma", url: "https://help.figma.com" },
      { icon: <FaPaintBrush />, name: "Adobe Suite", url: "https://helpx.adobe.com" },
      { icon: <SiCanva />, name: "Canva", url: "https://www.canva.com/designschool" },
      { icon: <SiBlender />, name: "Blender", url: "https://docs.blender.org" },
    ],
  },
  {
    title: "API & Testing",
    items: [
      { icon: <SiPostman />, name: "Postman", url: "https://learning.postman.com/docs" },
      { icon: <SiInsomnia />, name: "Insomnia", url: "https://docs.insomnia.rest" },
      { icon: <SiSwagger />, name: "Swagger", url: "https://swagger.io/docs" },
      { icon: <SiStorybook />, name: "Storybook", url: "https://storybook.js.org/docs" },
      { icon: <SiJest />, name: "Jest", url: "https://jestjs.io/docs/getting-started" },
      { icon: <SiMocha />, name: "Mocha", url: "https://mochajs.org" },
      { icon: <SiCypress />, name: "Cypress", url: "https://docs.cypress.io" },
      { icon: <SiSelenium />, name: "Selenium", url: "https://www.selenium.dev/documentation" },
    ],
  },
  {
    title: "Cloud & Hosting",
    items: [
      { icon: <SiFirebase />, name: "Firebase", url: "https://firebase.google.com/docs" },
      { icon: <SiGooglecloud />, name: "Google Cloud", url: "https://cloud.google.com/docs" },
      { icon: <FaAws />, name: "AWS", url: "https://docs.aws.amazon.com" },
      { icon: <SiCloudflare />, name: "Cloudflare", url: "https://developers.cloudflare.com" },
      { icon: <SiDigitalocean />, name: "DigitalOcean", url: "https://docs.digitalocean.com" },
      { icon: <SiHeroku />, name: "Heroku", url: "https://devcenter.heroku.com" },
      { icon: <SiNetlify />, name: "Netlify", url: "https://docs.netlify.com" },
      { icon: <SiVercel />, name: "Vercel", url: "https://vercel.com/docs" },
      { icon: <SiRender />, name: "Render", url: "https://docs.render.com" },
      { icon: <SiGithubpages />, name: "GitHub Pages", url: "https://docs.github.com/en/pages" },
      { icon: <SiPlesk />, name: "Plesk", url: "https://docs.plesk.com" },
      { icon: <SiCpanel />, name: "cPanel", url: "https://docs.cpanel.net" },
      { icon: <BsCloudFill />, name: "Cloud Panel", url: "https://www.cloudpanel.io/docs" },
    ],
  },
  {
    title: "Infrastructure & Monitoring",
    items: [
      { icon: <SiDocker />, name: "Docker", url: "https://docs.docker.com" },
      { icon: <SiTerraform />, name: "Terraform", url: "https://developer.hashicorp.com/terraform/docs" },
      { icon: <SiAnsible />, name: "Ansible", url: "https://docs.ansible.com" },
      { icon: <SiNginx />, name: "Nginx", url: "https://nginx.org/en/docs" },
      { icon: <SiGrafana />, name: "Grafana", url: "https://grafana.com/docs" },
      { icon: <SiPrometheus />, name: "Prometheus", url: "https://prometheus.io/docs" },
      { icon: <SiDatadog />, name: "Datadog", url: "https://docs.datadoghq.com" },
      { icon: <SiSentry />, name: "Sentry", url: "https://docs.sentry.io" },
      { icon: <SiNewrelic />, name: "New Relic", url: "https://docs.newrelic.com" },
    ],
  },
  {
    title: "AI Tools",
    items: [
      { icon: <TbBrandOpenai />, name: "ChatGPT", url: "https://platform.openai.com/docs" },
      { icon: <AiOutlineRobot />, name: "Claude AI", url: "https://docs.anthropic.com" },
      { icon: <BsRobot />, name: "DeepSeek AI", url: "https://platform.deepseek.com/docs" },
      { icon: <SiGooglegemini />, name: "Gemini AI", url: "https://ai.google.dev/docs" },
      { icon: <FaRobot />, name: "Ollama AI", url: "https://ollama.com" },
      { icon: <FaRobot />, name: "Lovable AI", url: "https://docs.lovable.dev" },
    ],
  },
  {
    title: "Payment & Communication",
    items: [
      { icon: <SiRazorpay />, name: "Razorpay", url: "https://razorpay.com/docs" },
      { icon: <SiStripe />, name: "Stripe", url: "https://docs.stripe.com" },
      { icon: <SiPaypal />, name: "PayPal", url: "https://developer.paypal.com/docs" },
      { icon: <SiTwilio />, name: "Twilio", url: "https://www.twilio.com/docs" },
      { icon: <SiSocketdotio />, name: "Socket.io", url: "https://socket.io/docs" },
      { icon: <SiMailchimp />, name: "Mailchimp", url: "https://mailchimp.com/developer" },
    ],
  },
  {
    title: "Analytics",
    items: [
      { icon: <SiGoogleanalytics />, name: "Google Analytics", url: "https://developers.google.com/analytics" },
      { icon: <SiHotjar />, name: "Hotjar", url: "https://help.hotjar.com" },
    ],
  },
  {
    title: "Package Managers & Linting",
    items: [
      { icon: <SiNpm />, name: "npm", url: "https://docs.npmjs.com" },
      { icon: <SiYarn />, name: "Yarn", url: "https://yarnpkg.com/getting-started" },
      { icon: <SiPnpm />, name: "pnpm", url: "https://pnpm.io" },
      { icon: <SiBun />, name: "Bun", url: "https://bun.sh/docs" },
      { icon: <SiEslint />, name: "ESLint", url: "https://eslint.org/docs/latest" },
      { icon: <SiPrettier />, name: "Prettier", url: "https://prettier.io/docs/en" },
    ],
  },
  {
    title: "Project Management & Collaboration",
    items: [
      { icon: <SiJira />, name: "Jira", url: "https://support.atlassian.com/jira-software-cloud" },
      { icon: <SiTrello />, name: "Trello", url: "https://support.atlassian.com/trello" },
      { icon: <SiNotion />, name: "Notion", url: "https://www.notion.so/help" },
      { icon: <SiSlack />, name: "Slack", url: "https://api.slack.com/docs" },
      { icon: <SiDiscord />, name: "Discord", url: "https://discord.com/developers/docs" },
      { icon: <BsMicrosoftTeams />, name: "MS Teams", url: "https://learn.microsoft.com/en-us/microsoftteams" },
      { icon: <SiZoom />, name: "Zoom", url: "https://developers.zoom.us/docs" },
    ],
  },
  {
    title: "OS & Terminal",
    items: [
      { icon: <SiLinux />, name: "Linux", url: "https://www.kernel.org/doc" },
      { icon: <SiUbuntu />, name: "Ubuntu", url: "https://help.ubuntu.com" },
      { icon: <SiDebian />, name: "Debian", url: "https://www.debian.org/doc" },
      { icon: <SiArchlinux />, name: "Arch Linux", url: "https://wiki.archlinux.org" },
      { icon: <SiAlpinelinux />, name: "Alpine Linux", url: "https://wiki.alpinelinux.org" },
      { icon: <SiParrotsecurity />, name: "Parrot OS", url: "https://parrotsec.org/docs" },
      { icon: <SiGnubash />, name: "Bash", url: "https://www.gnu.org/software/bash/manual" },
      { icon: <TbBrandPowershell />, name: "PowerShell", url: "https://learn.microsoft.com/en-us/powershell" },
      { icon: <IoLogoIonic />, name: "IoT", url: "https://www.arduino.cc/reference/en" },
    ],
  },
  {
    title: "Security, Auth & Pen Testing",
    items: [
      { icon: <SiKalilinux />, name: "Kali Linux", url: "https://www.kali.org/docs" },
      { icon: <SiBurpsuite />, name: "Burp Suite", url: "https://portswigger.net/burp/documentation" },
      { icon: <SiWireshark />, name: "Wireshark", url: "https://www.wireshark.org/docs" },
      { icon: <SiMetasploit />, name: "Metasploit", url: "https://docs.metasploit.com" },
      { icon: <SiOpenvpn />, name: "OpenVPN", url: "https://openvpn.net/community-resources" },
      { icon: <SiOwasp />, name: "OWASP", url: "https://owasp.org" },
      { icon: <SiSnyk />, name: "Snyk", url: "https://docs.snyk.io" },
      { icon: <SiHackthebox />, name: "Hack The Box", url: "https://www.hackthebox.com" },
      { icon: <SiTryhackme />, name: "TryHackMe", url: "https://tryhackme.com" },
      { icon: <SiSplunk />, name: "Splunk", url: "https://docs.splunk.com" },
      { icon: <SiPaloaltonetworks />, name: "Palo Alto", url: "https://docs.paloaltonetworks.com" },
      { icon: <SiAuth0 />, name: "Auth0", url: "https://auth0.com/docs" },
      { icon: <SiJsonwebtokens />, name: "JWT", url: "https://jwt.io/introduction" },
      { icon: <SiLetsencrypt />, name: "Let's Encrypt", url: "https://letsencrypt.org/docs" },
      { icon: <SiBitwarden />, name: "Bitwarden", url: "https://bitwarden.com/help" },
      { icon: <SiHashicorp />, name: "HashiCorp", url: "https://developer.hashicorp.com" },
      { icon: <SiVault />, name: "Vault", url: "https://developer.hashicorp.com/vault/docs" },
      { icon: <SiCloudinary />, name: "Cloudinary", url: "https://cloudinary.com/documentation" },
    ],
  },
];

function Toolstack() {
  return (
    <div>
      {sections.map((section, idx) => (
        <div key={idx} style={{ marginBottom: "30px" }}>
          <h2 className="tech-section-title">{section.title}</h2>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "10px",
              paddingBottom: "20px",
            }}
          >
            {section.items.map((tool, index) => (
              <a
                href={tool.url}
                target="_blank"
                rel="noopener noreferrer"
                className="tech-icons"
                key={index}
                title={tool.name}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {tool.icon}
                <span className="tech-icon-name">{tool.name}</span>
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Toolstack;
